import { useEffect, type ReactElement } from "react";
import type { KpiTableParams } from "@playbookai/widget-schemas";
import { KpiPickList } from "../KpiPickList.js";
import { useKpiCatalog } from "../kpi-catalog.js";
import type { DashboardWidgetEditorProps } from "../types.js";

export function KpiTableEditor({
  draftParams,
  onChange,
}: DashboardWidgetEditorProps): ReactElement {
  const catalog = useKpiCatalog();
  const params = draftParams as KpiTableParams;
  const activate = catalog?.activate;
  useEffect(() => {
    activate?.(params.kpiIds ?? []);
  }, [activate, params.kpiIds]);
  return (
    <fieldset className="space-y-2">
      <legend className="mb-2 text-sm font-semibold text-pb-text">
        Choose KPIs
      </legend>
      <p className="text-dense-1 text-pb-text-muted">
        Select the measures you want to follow in this table.
      </p>
      <KpiPickList
        name="kpi-table"
        multiple
        selectedIds={params.kpiIds ?? []}
        onSelectionChange={(kpiIds) => onChange({ ...params, kpiIds })}
      />
    </fieldset>
  );
}
